// extracted by mini-css-extract-plugin
module.exports = {"root":"technicalWorks_root__ui80F","main":"technicalWorks_main__fHQU1","link":"technicalWorks_link__1lSPv"};